import { render } from "./XsjdPage.vue?vue&type=template&id=4058fcc4"
import script from "./XsjdPage.vue?vue&type=script&lang=js"
export * from "./XsjdPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__